(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiwify-circle-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var CAROUSELS = [
      {
        selector: '.appstleLoyaltyPageV2WaysToRedeemList',
        prevLabel: 'Önceki ödüller',
        nextLabel: 'Sonraki ödüller'
      },
      {
        selector: '.appstleLoyaltyPageV2RewardsList',
        prevLabel: 'Önceki kazanılan ödüller',
        nextLabel: 'Sonraki kazanılan ödüller'
      }
    ];

    var SVG_PREV =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></svg>';
    var SVG_NEXT =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>';

    function prefersReducedMotion() {
      if (!window.matchMedia) return false;
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollBehavior() {
      return prefersReducedMotion() ? 'auto' : 'smooth';
    }

    function makeArrow(direction, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'wc-redeem-arrow wc-redeem-arrow--' + direction;
      button.setAttribute('aria-label', label);
      button.innerHTML = direction === 'prev' ? SVG_PREV : SVG_NEXT;
      return button;
    }

    /* Half the arrow height (40px) — the buttons are placed by their own top edge. */
    var ARROW_HALF = 20;
    var syncers = [];

    function rafDebounce(fn) {
      var pending = false;
      return function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          fn();
        });
      };
    }

    function syncAll() {
      for (var i = 0; i < syncers.length; i++) {
        syncers[i]();
      }
    }

    var scheduleSyncAll = rafDebounce(syncAll);

    function buildOne(mount, config) {
      var list = mount.querySelector(config.selector);
      if (!list) return false;

      var wrap = list.parentNode;
      if (!wrap || wrap.nodeType !== 1) return false;

      if (wrap.getAttribute('data-wc-carousel') === '1' && wrap.querySelector('.wc-redeem-arrow')) {
        return true;
      }

      wrap.setAttribute('data-wc-carousel', '1');
      wrap.classList.add('wc-redeem-wrap');

      var prev = makeArrow('prev', config.prevLabel);
      var next = makeArrow('next', config.nextLabel);

      /* Vertical centre of the list, measured against the positioned wrapper. */
      function centreTop() {
        if (list.offsetParent === wrap) {
          return list.offsetTop + list.offsetHeight / 2 - ARROW_HALF;
        }

        var listRect = list.getBoundingClientRect();
        var wrapRect = wrap.getBoundingClientRect();
        return listRect.top - wrapRect.top + listRect.height / 2 - ARROW_HALF;
      }

      function sync() {
        var scrollable = list.scrollWidth > list.clientWidth + 2;
        prev.style.display = scrollable ? '' : 'none';
        next.style.display = scrollable ? '' : 'none';
        if (!scrollable) return;

        var top = Math.round(centreTop()) + 'px';
        prev.style.top = top;
        next.style.top = top;

        var max = list.scrollWidth - list.clientWidth - 2;
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max;
      }

      var scheduleSync = rafDebounce(sync);
      syncers.push(scheduleSync);

      prev.addEventListener('click', function () {
        list.scrollBy({ left: -list.clientWidth, behavior: scrollBehavior() });
      });

      next.addEventListener('click', function () {
        list.scrollBy({ left: list.clientWidth, behavior: scrollBehavior() });
      });

      list.addEventListener('scroll', scheduleSync, { passive: true });

      wrap.appendChild(prev);
      wrap.appendChild(next);

      sync();
      window.setTimeout(sync, 400);
      window.setTimeout(sync, 1200);

      return true;
    }

    function build(mount) {
      var built = false;
      for (var i = 0; i < CAROUSELS.length; i++) {
        if (buildOne(mount, CAROUSELS[i])) built = true;
      }
      return built;
    }

    function watch(mount) {
      var root = mount.querySelector('#appstleLoyaltyPage') || mount;
      var pending = null;

      var observer = new MutationObserver(function () {
        if (pending) return;
        pending = window.setTimeout(function () {
          pending = null;
          build(mount);
          scheduleSyncAll();
        }, 150);
      });

      observer.observe(root, { childList: true, subtree: true });
      build(mount);
    }

    function onTabClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('.wiwify-tab-btn')) return;

      window.setTimeout(function () {
        var selector = CAROUSELS.map(function (config) {
          return '.wc-panel__mount ' + config.selector;
        }).join(', ');
        var lists = document.querySelectorAll(selector);
        for (var i = 0; i < lists.length; i++) {
          lists[i].scrollTo({ left: 0, behavior: scrollBehavior() });
        }
        scheduleSyncAll();
      }, 60);

      window.setTimeout(syncAll, 400);
    }

    function start() {
      var mounts = document.querySelectorAll('.wc-panel__mount[data-wc-carousel-enabled="true"]');
      if (!mounts.length) return;
      for (var i = 0; i < mounts.length; i++) {
        watch(mounts[i]);
      }
      document.addEventListener('click', onTabClick);
      window.addEventListener('resize', scheduleSyncAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiwify-circle-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MOBILE_QUERY = '(max-width: 749px)';

    function reducedMotion() {
      if (!window.matchMedia) return false;
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isMobile() {
      if (!window.matchMedia) return true;
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    function setup(root) {
      if (root.getAttribute('data-wc-tiers-ready') === '1') return;
      root.setAttribute('data-wc-tiers-ready', '1');

      var track = root.querySelector('[data-wc-tiers-track]');
      if (!track) return;

      var cards = track.querySelectorAll('.wc-tiers__card');
      if (cards.length < 2) return;

      var prev = root.querySelector('[data-wc-tiers-prev]');
      var next = root.querySelector('[data-wc-tiers-next]');
      var dots = root.querySelectorAll('[data-wc-tiers-dot]');

      function step() {
        var pitch = cards[1].offsetLeft - cards[0].offsetLeft;
        if (pitch > 0) return pitch;
        return track.clientWidth;
      }

      function activeIndex() {
        var pitch = step();
        if (pitch <= 0) return 0;
        var index = Math.round(track.scrollLeft / pitch);
        if (index < 0) index = 0;
        if (index > cards.length - 1) index = cards.length - 1;
        return index;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth;

        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;

        var index = activeIndex();
        for (var i = 0; i < dots.length; i++) {
          if (i === index) {
            dots[i].setAttribute('aria-current', 'true');
          } else {
            dots[i].removeAttribute('aria-current');
          }
        }
      }

      var pending = false;
      function scheduleSync() {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          sync();
        });
      }

      function go(delta) {
        track.scrollBy({
          left: delta * step(),
          behavior: reducedMotion() ? 'auto' : 'smooth',
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          go(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          go(1);
        });
      }

      for (var d = 0; d < dots.length; d++) {
        (function (button) {
          button.addEventListener('click', function () {
            var target = parseInt(button.getAttribute('data-wc-tiers-dot'), 10) || 0;
            track.scrollTo({
              left: target * step(),
              behavior: reducedMotion() ? 'auto' : 'smooth',
            });
          });
        })(dots[d]);
      }

      track.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync);

      /* Açılışta ilk kart (Glow); müşterinin seviyesi biliniyorsa animasyonsuz o karta git. */
      var current = track.querySelector('[data-wc-tier-current="true"]');
      if (current && isMobile()) {
        var index = parseInt(current.getAttribute('data-wc-tier-index'), 10) || 0;
        if (index > 0) {
          var previousBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = index * step();
          track.style.scrollBehavior = previousBehavior;
        }
      }

      sync();
    }

    function start() {
      var roots = document.querySelectorAll('[data-wc-tiers-carousel]');
      for (var i = 0; i < roots.length; i++) {
        setup(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiwify-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Kanal rozeti: isim listesi tema ayarlarındaki "Pazaryeri" bloklarından
    // gelir (i18n.channels). Bu harita yalnız son yedektir.
    var CHANNEL_FALLBACK = { trendyol: 'Trendyol', hepsiburada: 'Hepsiburada' };

    var TIER_COLORS = { glow: '#B87333', shine: '#A8A9AD', radiant: '#C9A227' };

    // Bilinen kodlarda TEMA AYARI önceliklidir (owner metni tema düzenleyiciden yönetir);
    // ayar boşsa buradaki yedek; kodu bilinmeyen yanıtlarda backend `message` alanı.
    var CODE_KEYS = {
      INVALID_ORDER_NUMBER: 'err_invalid_order_number Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      TRACKING_NUMBER: 'err_tracking_number Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      BEFORE_START: 'err_before_start Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      TOO_OLD: 'err_too_old Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      NOT_DELIVERED: 'err_not_delivered',
      CANCELLED: 'err_cancelled Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      NO_ELIGIBLE_ITEMS: 'err_no_eligible_items Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      RATE_LIMITED: 'err_rate_limited Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      BAD_SIGNATURE: 'err_bad_signature Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      STALE: 'err_stale Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.'
    };

    var CODE_FALLBACK = {
      INVALID_ORDER_NUMBER: 'Sipariş numarası 8-12 haneli olmalı. Numarayı kontrol edip tekrar dener misin?',
      TRACKING_NUMBER: 'Bu numara bir kargo takip numarasına benziyor. Trendyol’da “Siparişlerim” altındaki 11 haneli Sipariş No’yu, Hepsiburada’da 10 haneli Sipariş Numarasını gir.',
      BEFORE_START: 'Bu sipariş program başlangıç tarihinden önce verilmiş, bu yüzden puan kazanamıyor.',
      TOO_OLD: 'Bu sipariş puan kazanmak için fazla eski.',
      NOT_DELIVERED: 'Siparişin sistemde henüz teslim edilmemiş görünüyor. WiwiPoint’lerin siparişin teslim edildikten sonra tanımlanacak. Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      CANCELLED: 'İptal edilen ya da iade edilen siparişler puan kazanamaz.',
      NO_ELIGIBLE_ITEMS: 'Bu siparişteki ürünler henüz puan kapsamında değil.',
      RATE_LIMITED: 'Bugün çok fazla deneme yaptın. Yarın tekrar dener misin?',
      BAD_SIGNATURE: 'Oturumunda bir sorun oluştu. Sayfayı yenileyip tekrar dener misin?',
      STALE: 'Oturumunda bir sorun oluştu. Sayfayı yenileyip tekrar dener misin?'
    };

    var STATUS_KEYS = {
      400: 'err_status_400 Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      404: 'err_status_404 Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      429: 'err_status_429 Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.',
      502: 'err_status_502 Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.'
    };

    var STATUS_FALLBACK = {
      400: 'Girdiğin bilgilerde bir sorun var. Kontrol edip tekrar dener misin?',
      404: 'Bu sipariş numarasını bulamadık. Numarayı kontrol eder misin?',
      429: 'Bugün çok fazla deneme yaptın. Yarın tekrar dener misin?',
      502: 'Şu an satış kanalına ulaşamıyoruz. Birazdan tekrar dener misin?'
    };

    var HISTORY_STATUS = {
      CREDITED: { key: 'status_credited', fallback: 'Eklendi', cls: 'wol-badge--ok' },
      SIMULATED: { key: 'status_credited', fallback: 'Eklendi', cls: 'wol-badge--ok' },
      PENDING: { key: 'status_pending', fallback: 'İşleniyor', cls: 'wol-badge--pending' },
      UNKNOWN: { key: 'status_unknown', fallback: 'İnceleniyor', cls: 'wol-badge--pending' },
      REVERSED: { key: 'status_reversed', fallback: 'İade — geri alındı', cls: 'wol-badge--bad' },
      FAILED: { key: 'status_failed', fallback: 'Başarısız', cls: 'wol-badge--muted' }
    };

    var GENERIC_ERROR_FALLBACK = 'Bir hata oluştu, lütfen tekrar dene. Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.';

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text != null) node.textContent = String(text);
      return node;
    }

    function fmtNum(n) {
      var v = Number(n);
      if (!isFinite(v)) return '0';
      try { return new Intl.NumberFormat('tr-TR').format(v); } catch (e) { return String(v); }
    }

    function fmtDate(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return d.toISOString().slice(0, 10); }
    }

    function maskOrder(no) {
      var s = String(no == null ? '' : no);
      if (s.length <= 4) return s;
      return new Array(s.length - 4 + 1).join('•') + s.slice(-4);
    }

    // Sunucudan gelen görsel adresini yalnız http(s) ise kullan.
    function safeImageUrl(u) {
      if (typeof u !== 'string' || !u) return null;
      try {
        var parsed = new URL(u, window.location.origin);
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.href;
      } catch (e) { /* geçersiz URL */ }
      return null;
    }

    function tierColor(t) {
      return TIER_COLORS[String(t || '').toLowerCase()] || '#c9c5bd';
    }

    function tierName(t) {
      if (t && typeof t === 'object') return String(t.name || '');
      return String(t == null ? '' : t);
    }

    // Tema düzenleyicideki metin haritası (<script type="application/json">).
    function readI18n(sid) {
      var node = document.getElementById('wol-i18n-' + sid);
      if (!node) return {};
      try {
        var parsed = JSON.parse(node.textContent || '{}');
        if (parsed && typeof parsed === 'object') return parsed;
      } catch (e) { /* bozuk JSON → yedek metinler */ }
      return {};
    }

    // fetch sarmalayıcı: her zaman {status, data} döner, JSON olmayan yanıtı yutar.
    function api(path, options) {
      var opts = options || {};
      return fetch(path, {
        method: opts.method || 'GET',
        headers: opts.body
          ? { 'Content-Type': 'application/json', 'Accept': 'application/json' }
          : { 'Accept': 'application/json' },
        body: opts.body ? JSON.stringify(opts.body) : undefined
      }).then(function (res) {
        return res.text().then(function (raw) {
          var data = null;
          try { data = JSON.parse(raw); } catch (e) { data = null; }
          if (data === null || typeof data !== 'object') data = null;
          return { status: res.status, ok: res.ok, data: data };
        });
      });
    }

    function init(root) {
      if (!root || root.dataset.wolInit === '1') return;
      root.dataset.wolInit = '1';

      var sid = root.dataset.sectionId;
      var T = root.dataset;
      var I = readI18n(sid);
      var loginUrl = T.loginUrl || '/customer_authentication/login';

      // Metin çözücü: tema ayarı boşsa koddaki yedek metne düşer.
      function t(key, fallback) {
        var v = I[key];
        if (typeof v === 'string' && v !== '') return v;
        return fallback == null ? '' : fallback;
      }

      var CHANNEL_NAMES = [];
      if (Object.prototype.toString.call(I.channels) === '[object Array]') {
        for (var ci = 0; ci < I.channels.length; ci++) {
          if (typeof I.channels[ci] === 'string' && I.channels[ci]) CHANNEL_NAMES.push(I.channels[ci]);
        }
      }

      function channelLabel(c) {
        var raw = String(c == null ? '' : c);
        var lower = raw.toLowerCase();
        if (!lower) return '';
        for (var i = 0; i < CHANNEL_NAMES.length; i++) {
          if (CHANNEL_NAMES[i].toLowerCase() === lower) return CHANNEL_NAMES[i];
        }
        return CHANNEL_FALLBACK[lower] || raw;
      }

      function genericError() {
        return t('error_message', GENERIC_ERROR_FALLBACK);
      }

      // --- Giriş CTA'sı --------------------------------------------------
      // assets/wiwify-login-redirect.js TÜM login linklerini
      // /community/wiwify-circle/ adresine döndürür; bu sayfanın CTA'sı ise
      // kendi sayfasına dönmek zorunda. KESİN ÇÖZÜM o script'e
      // `data-login-return-keep` atlamasını eklemektir (bkz. dosya başı notu).
      document.addEventListener('click', function (event) {
        var t2 = event.target;
        var a = t2 && t2.closest ? t2.closest('a[data-wol-login]') : null;
        if (!a) return;
        a.setAttribute('href', loginUrl);
        event.stopImmediatePropagation();
      }, true);

      if (T.loggedIn !== '1') return;

      var form = document.getElementById('wol-form-' + sid);
      var input = document.getElementById('wol-input-' + sid);
      var submit = document.getElementById('wol-submit-' + sid);
      var loading = document.getElementById('wol-loading-' + sid);
      var loadingText = loading ? loading.querySelector('.wol-loading__text') : null;
      var errorEl = document.getElementById('wol-error-' + sid);
      var resultEl = document.getElementById('wol-result-' + sid);
      var historyEl = document.getElementById('wol-history-' + sid);
      var historyList = document.getElementById('wol-history-list-' + sid);
      var historyEmpty = document.getElementById('wol-history-empty-' + sid);

      if (!form || !input || !submit) return;

      function hideAll() {
        [loading, errorEl, resultEl].forEach(function (e) {
          if (e) e.classList.remove('is-visible');
        });
      }

      function showLoading(text) {
        hideAll();
        if (loadingText) loadingText.textContent = text || t('loading_text', '');
        if (loading) loading.classList.add('is-visible');
      }

      function showError(msg) {
        hideAll();
        if (!errorEl) return;
        errorEl.textContent = msg || genericError();
        errorEl.classList.add('is-visible');
      }

      function showResult(node) {
        hideAll();
        if (!resultEl) return;
        resultEl.textContent = '';
        resultEl.appendChild(node);
        resultEl.classList.add('is-visible');
      }

      function goLogin() {
        window.location.href = loginUrl;
      }

      function codeMessage(code) {
        var key = CODE_KEYS[code];
        if (!key) return '';
        return t(key, CODE_FALLBACK[code] || '');
      }

      function statusMessage(status) {
        var key = STATUS_KEYS[status];
        if (!key) return '';
        return t(key, STATUS_FALLBACK[status] || '');
      }

      function messageFor(res) {
        var d = res.data;
        // Bilinen kod → tema ayarındaki metin (owner düzenler); bilinmeyen kod → backend mesajı.
        if (d && d.code) {
          var byCode = codeMessage(d.code);
          if (byCode) return byCode;
        }
        if (d && typeof d.message === 'string' && d.message) return d.message;
        var byStatus = statusMessage(res.status);
        if (byStatus) return byStatus;
        return genericError();
      }

      function setBusy(isBusy, label) {
        submit.disabled = isBusy;
        submit.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        if (label) submit.textContent = label;
      }

      input.addEventListener('input', function () {
        var pos = input.selectionStart;
        var before = input.value;
        var cleaned = before.replace(/\D+/g, '').slice(0, 16);
        if (cleaned !== before) {
          var removed = before.length - cleaned.length;
          input.value = cleaned;
          var next = Math.max(0, (pos == null ? cleaned.length : pos) - removed);
          try { input.setSelectionRange(next, next); } catch (e) { /* yoksay */ }
        }
        input.removeAttribute('aria-invalid');
      });

      // ---------- Sipariş kartı (önizleme + teslim edilmemiş durumu ortak) ----------
      // opts.badgeText / opts.badgeCls: sağ üstteki durum rozeti (varsayılan: Teslim Edildi, yeşil).
      function buildOrderCard(data, opts) {
        var o = opts || {};
        var unit = t('points_unit', 'WiwiPoint');
        var card = el('div', 'wol-result__card');

        var header = el('div', 'wol-result__header');
        var left = el('div', 'wol-result__left');
        left.appendChild(el('span', 'wol-result__number', data.orderNumber || ''));
        var chLabel = channelLabel(data.channel);
        if (chLabel) left.appendChild(el('span', 'wol-result__channel', chLabel));
        header.appendChild(left);

        var meta = el('div', 'wol-result__left');
        var dateStr = fmtDate(data.orderDate);
        if (dateStr) meta.appendChild(el('span', 'wol-result__date', dateStr));
        meta.appendChild(el('span', 'wol-badge ' + (o.badgeCls || 'wol-badge--ok'),
          o.badgeText || t('delivered_badge_label', 'Teslim Edildi')));
        header.appendChild(meta);
        card.appendChild(header);

        var list = el('ul', 'wol-items');
        var items = Array.isArray(data.items) ? data.items : [];
        items.forEach(function (item) {
          var matched = item.matched !== false && Number(item.points) > 0;
          var li = el('li', 'wol-item' + (matched ? '' : ' wol-item--muted'));

          var src = safeImageUrl(item.imageUrl);
          if (src) {
            // Shopify CDN: küçük görsel iste (retina için 128px), mevcut ?v= parametresini koru.
            try { var su = new URL(src); if (/cdn\.shopify\.com$/.test(su.hostname) && !su.searchParams.has('width')) { su.searchParams.set('width', '128'); src = su.href; } } catch (e) { /* olduğu gibi kullan */ }
            var img = el('img', 'wol-item__img');
            img.src = src;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 64;
            img.height = 64;
            li.appendChild(img);
          } else {
            li.appendChild(el('div', 'wol-item__placeholder'));
          }

          var info = el('div', 'wol-item__info');
          // Ürün adı Shopify'daki başlık; eşleşen ürün, mağazadaki ürün sayfasına bağlanır.
          var nameEl = el('p', 'wol-item__name');
          var productHref = (typeof item.productUrl === 'string' && item.productUrl.indexOf('/products/') === 0) ? item.productUrl : null;
          if (productHref) {
            var a = el('a', 'wol-item__link', item.name || '');
            a.href = productHref;
            nameEl.appendChild(a);
          } else {
            nameEl.textContent = item.name || '';
          }
          info.appendChild(nameEl);
          var qty = Number(item.quantity) || 1;
          var each = Number(item.pointsEach) || 0;
          info.appendChild(el(
            'p',
            'wol-item__meta',
            matched
              ? (qty + '\u00A0' + t('quantity_unit', 'adet') + ' × ' + fmtNum(each) + '\u00A0' + unit)
              : t('item_not_eligible_text', 'Bu ürün puan kapsamında değil')
          ));
          li.appendChild(info);

          if (matched) {
            li.appendChild(el('span', 'wol-item__points', '+' + fmtNum(item.points) + '\u00A0' + unit));
          }
          list.appendChild(li);
        });
        card.appendChild(list);

        var total = el('div', 'wol-total');
        total.appendChild(el('span', 'wol-total__label', t('total_points_label', 'Kazanacağın puan')));
        var value = el('span', 'wol-total__value', fmtNum(data.points));
        // Sayı ile birim arasına bölünmez boşluk: "1 WiwiPoint" (eskiden "1WiwiPoint").
        value.appendChild(document.createTextNode('\u00A0'));
        value.appendChild(el('span', 'wol-total__unit', unit));
        total.appendChild(value);
        card.appendChild(total);
        return card;
      }

      // ---------- Önizleme (teslim edilmiş, puan alınabilir) ----------
      function renderPreview(data) {
        var wrap = el('div', null);
        wrap.appendChild(buildOrderCard(data));

        var confirm = el('button', 'button wol-btn wol-btn--block wol-confirm', t('claim_button_label', 'Puanları Hesabıma Ekle'));
        confirm.type = 'button';
        confirm.addEventListener('click', function () {
          confirm.disabled = true;
          confirm.setAttribute('aria-busy', 'true');
          doClaim(data.orderNumber, confirm);
        });
        wrap.appendChild(confirm);

        showResult(wrap);
      }

      // ---------- Sipariş bulundu ama HENÜZ TESLİM EDİLMEDİ ----------
      // Backend 422 NOT_DELIVERED yanıtında siparişi (kalemler, kazanılacak puan) da gönderir:
      // müşteri siparişinin tanındığını ve teslimden sonra kaç puan alacağını görür; ekleme
      // düğmesi yoktur, yerine bilgi kutusu vardır. Metin tema ayarı `err_not_delivered`.
      function renderNotDelivered(data) {
        var wrap = el('div', null);
        wrap.appendChild(buildOrderCard(data, {
          badgeText: t('not_delivered_badge_label', 'Henüz teslim edilmedi'),
          badgeCls: 'wol-badge--pending'
        }));
        var notice = el('div', 'wol-notice', codeMessage('NOT_DELIVERED'));
        notice.setAttribute('role', 'status');
        wrap.appendChild(notice);
        showResult(wrap);
      }

      // Önizleme modunda (claim.status === 'SIMULATED') backend balance = null
      // döner; canlıda ise balance dolu gelir. Kart iki durumda da aynıdır,
      // yalnız bakiye/seviye satırı balance varsa eklenir.
      function renderSuccess(data) {
        var claim = data.claim || {};
        var balance = claim.balance;
        var box = el('div', 'wol-success');

        box.appendChild(el('p', 'wol-success__title', t('success_title', 'Puanların hesabına eklendi')));
        box.appendChild(el('p', 'wol-success__points', '+' + fmtNum(data.points)));
        box.appendChild(el('p', 'wol-success__unit', t('points_unit', 'WiwiPoint')));

        if (typeof data.message === 'string' && data.message) {
          box.appendChild(el('p', 'wol-success__message', data.message));
        }

        if (balance && typeof balance === 'object') {
          var facts = el('div', 'wol-success__facts');

          if (balance.availablePoints != null) {
            var f1 = el('div', 'wol-fact');
            f1.appendChild(el('div', 'wol-fact__value', fmtNum(balance.availablePoints)));
            f1.appendChild(el('div', 'wol-fact__label', t('balance_label', 'Toplam puanın')));
            facts.appendChild(f1);
          }

          var tier = tierName(balance.currentVipTier);
          if (tier) {
            var f2 = el('div', 'wol-fact');
            var v2 = el('div', 'wol-fact__value');
            var dot = el('span', 'wol-tier-dot');
            dot.style.background = tierColor(tier);
            v2.appendChild(dot);
            v2.appendChild(el('span', null, tier));
            f2.appendChild(v2);
            f2.appendChild(el('div', 'wol-fact__label', t('tier_label', 'Seviyen')));
            facts.appendChild(f2);
          }

          if (facts.childNodes.length) box.appendChild(facts);
        }

        var cta = el('div', 'wol-success__cta');
        var link = el('a', 'button wol-btn', t('circle_link_label', "Wiwify Circle'a git"));
        link.href = T.circleUrl || '/pages/wiwify-circle';
        cta.appendChild(link);
        box.appendChild(cta);

        var note = t('success_note', '');
        if (note) box.appendChild(el('p', 'wol-success__note', note));

        showResult(box);
      }

      function renderAlreadyClaimed(res) {
        var d = res.data || {};
        var box = el('div', 'wol-claimed');
        box.appendChild(el('p', 'wol-claimed__title', d.claimedByMe
          ? t('already_claimed_mine_title', 'Bu siparişin puanlarını zaten aldın')
          : t('already_claimed_other_title', 'Bu sipariş numarası daha önce kullanılmış')));
        box.appendChild(el('p', 'wol-claimed__text', d.claimedByMe
          ? t('already_claimed_mine_text', d.message || 'Bu siparişin WiwiPoint’leri hesabına daha önce eklendi. Bir sorun olduğunu düşünüyorsan info@wiwify.com adresinden bize ulaşabilirsin.')
          : t('already_claimed_other_text', d.message || 'Bu sipariş numarası için puanlar daha önce talep edilmiş. Bir yanlışlık olduğunu düşünüyorsan info@wiwify.com adresine yazabilirsin.')));

        var link = el('a', 'wol-link', t('circle_link_label', "Wiwify Circle'a git"));
        link.href = T.circleUrl || '/pages/wiwify-circle';
        box.appendChild(link);

        showResult(box);
      }

      function handleFailure(res) {
        if (res.status === 401 || (res.data && res.data.code === 'LOGIN_REQUIRED')) {
          goLogin();
          return true;
        }
        if (res.status === 409) {
          renderAlreadyClaimed(res);
          return true;
        }
        if (res.data && res.data.code === 'NOT_DELIVERED' && Array.isArray(res.data.items) && res.data.items.length) {
          renderNotDelivered(res.data);
          return true;
        }
        showError(messageFor(res));
        return true;
      }

      function doClaim(orderNumber, confirmBtn) {
        showLoading(t('claiming_text', t('loading_text', '')));
        api('/apps/journey/claim', { method: 'POST', body: { orderNumber: orderNumber } })
          .then(function (res) {
            if (res.ok && res.data && res.data.ok) {
              renderSuccess(res.data);
              loadHistory();
              return;
            }
            handleFailure(res);
          })
          .catch(function () {
            showError(genericError());
          })
          .then(function () {
            if (confirmBtn) {
              confirmBtn.disabled = false;
              confirmBtn.removeAttribute('aria-busy');
            }
          });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var value = input.value.replace(/\D+/g, '');
        input.value = value;

        // Canlıda görüldü (22.09 + 29.09): müşteriler Trendyol'un 16 haneli KARGO TAKİP
        // numarasını (7330037…) giriyor. 13-16 hane → sipariş no değil, takip no uyarısı.
        if (value.length >= 13 && value.length <= 16) {
          input.setAttribute('aria-invalid', 'true');
          showError(codeMessage('TRACKING_NUMBER'));
          input.focus();
          return;
        }
        if (value.length < 8 || value.length > 12) {
          input.setAttribute('aria-invalid', 'true');
          showError(codeMessage('INVALID_ORDER_NUMBER'));
          input.focus();
          return;
        }

        setBusy(true);
        showLoading(t('loading_text', ''));

        api('/apps/journey/preview', { method: 'POST', body: { orderNumber: value } })
          .then(function (res) {
            if (res.ok && res.data && res.data.ok) {
              if (res.data.eligible === false || !Number(res.data.points)) {
                showError(res.data.message || codeMessage('NO_ELIGIBLE_ITEMS'));
                return;
              }
              renderPreview(res.data);
              return;
            }
            handleFailure(res);
          })
          .catch(function () {
            showError(genericError());
          })
          .then(function () {
            setBusy(false, t('preview_button_label', ''));
          });
      });

      // ---------- Son kazanımlar (sayfa yüklendikten sonra) ----------
      function renderHistory(rows) {
        if (!historyEl || !historyList) return;
        historyList.textContent = '';
        rows.forEach(function (row) {
          var li = el('li', 'wol-history__item');

          var main = el('div', 'wol-history__main');
          main.appendChild(el('p', 'wol-history__order', maskOrder(row.orderNumber)));
          var parts = [];
          var d = fmtDate(row.creditedAt || row.createdAt || row.claimedAt || row.date);
          if (d) parts.push(d);
          var cl = channelLabel(row.channel);
          if (cl) parts.push(cl);
          main.appendChild(el('p', 'wol-history__meta', parts.join(' · ')));
          li.appendChild(main);

          var pts = Number(row.points) || 0;
          li.appendChild(el('span', 'wol-history__points',
            (String(row.status).toUpperCase() === 'REVERSED' ? '−' : '+') + fmtNum(Math.abs(pts))));

          var st = HISTORY_STATUS[String(row.status || '').toUpperCase()] || HISTORY_STATUS.CREDITED;
          li.appendChild(el('span', 'wol-badge ' + st.cls, t(st.key, st.fallback)));

          historyList.appendChild(li);
        });

        // Boş geçmiş: bölüm gizlenmez, ayardan gelen boş durum metni gösterilir.
        var isEmpty = rows.length === 0;
        historyList.hidden = isEmpty;
        if (historyEmpty) historyEmpty.hidden = !isEmpty;
        historyEl.hidden = isEmpty && !historyEmpty;
      }

      function loadHistory() {
        if (!historyEl) return;
        api('/apps/journey/me')
          .then(function (res) {
            if (!res.ok || !res.data || res.data.ok === false) return;
            var d = res.data;
            var rows = d.claims || d.items || d.history || [];
            if (!Array.isArray(rows)) rows = [];
            renderHistory(rows);
          })
          .catch(function () { /* geçmiş kritik değil, sessizce geç */ });
      }

      function deferHistory() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadHistory, { timeout: 2000 });
        } else {
          window.setTimeout(loadHistory, 400);
        }
      }

      if (document.readyState === 'complete') deferHistory();
      else window.addEventListener('load', deferHistory, { once: true });
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('.wol-section[data-section-id]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
